import moment from "moment";
import * as QueryString from "querystring";
import { InitPage } from "../index";
import axios from "axios";
import swal from "sweetalert";
import { String } from "lodash";
import { shallowEqual } from "react-redux";

declare let isClientERCReceiving: string;
declare let ercReceivingLogsUrl: string;
declare let tenantCode: string;
declare let showUndetected: string;
declare let App: any;

class ERCReceiving {
  private ercReceivingChannel: any;

  init() {
    var x = (typeof tenantCode === "undefined") ? "not_available" : tenantCode;

    if (isClientERCReceiving === 'true') {
      this.ercReceivingChannel = App.cable.subscriptions.create(
        {
          channel: "ERC::ReceivingChannel",
          tenant_code: x,
          roomId: `erc_receiving_${x}`
        },
        {
          connected() {
            console.log("Connected to ERC receiving channel");
          },
          disconnected() {
            console.log("Disconnected to ERC receiving channel");
          },
          received: (data: any) => this.refreshReceivingData(data)
        }
      );
    }

    const self = this;
    $('#show_undetected').change(function() {
      var checkbox = $(this);
      if (checkbox.prop('checked')) {
        showUndetected = 'true';
        document.cookie = `${tenantCode}_show_only_undetected_items=1;path=/`;
        self.refreshReceivingData({});
      } else {
        showUndetected = 'false';
        document.cookie = `${tenantCode}_show_only_undetected_items=0;path=/`;
        self.refreshReceivingData({});
      }
    });

  }

  refreshReceivingData(data) {
    axios.get(`${ercReceivingLogsUrl}?undetected=${showUndetected}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    }).then(function(response) {
      $(`#erc_receiving_logs`).html(response.data.html);
    }).catch(function(error) {
      window.toastr_notifications.error(error.response.data.error, "Error");
    });
  }
}

export function LoadPage() {
  InitPage("receiving_logs", () => {
    const receiving = new ERCReceiving();
    receiving.init();
  });
}
